import React from 'react';
import styled, { css, type RuleSet } from 'styled-components';
import * as fontSize from 'autogen/design-tokens/global/font';
import { mediaQueryStyling } from 'helpers/mediaQueryStyling';
import { getFontSizeByNumber } from '../shared/helpers';
import type { availableFontSizeTypes, breakPointObject, IText } from '../types';

const resolveFontSize = (sizeAsNumber: availableFontSizeTypes) =>
    `font-size: ${getFontSizeByNumber(sizeAsNumber) || fontSize.FontSize16};`;

type BreakpointFontSize = breakPointObject<RuleSet>;

function handleMediaQueries(textSize: breakPointObject) {
    const breakpointFontSize = Object.keys(textSize).reduce<BreakpointFontSize>((acc, key) => {
        acc[key] = resolveFontSize(textSize[key]);
        return acc;
    }, {});

    return mediaQueryStyling(breakpointFontSize);
}

const TextElement = styled.span<{ $size: IText['size']; nowrap?: IText['nowrap'] }>`
    ${({ $size }) => $size && (typeof $size === 'object' ? handleMediaQueries($size) : resolveFontSize($size))}
    ${({ nowrap }) =>
        nowrap &&
        css`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `}
`;

export default function Text({ size, children, ...restProps }: IText): JSX.Element {
    return (
        <TextElement $size={size} {...restProps}>
            {children}
        </TextElement>
    );
}
